import { Trans } from '@lingui/react/macro';
import { Container } from './styled';
export function SkipNav(props) {
    const { target } = props;
    return (<Container href={`#${target}`}>
      <Trans>Skip to content</Trans>
    </Container>);
}
